import { StorePlayerColor, StoreItemCategory } from '../../entity_datas/StoreEnums.ts';
import { BaseStoreItem } from '../BaseStoreItem.ts';
import { LobbyImage } from '@colonist/types';
export class SIColorGold extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Gold, this.name = {
            key: 'strings:colonistCommon.playerColors.Gold'
        }, this.price = 300000, this.image = LobbyImage.StoreColorGold, this.activeInStore = false;
    }
}
export class SIColorSilver extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Silver, this.name = {
            key: 'strings:colonistCommon.playerColors.Silver'
        }, this.price = 300000, this.image = LobbyImage.StoreColorSilver, this.activeInStore = false;
    }
}
export class SIColorBronze extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Bronze, this.name = {
            key: 'strings:colonistCommon.playerColors.Bronze'
        }, this.price = 300000, this.image = LobbyImage.StoreColorBronze, this.activeInStore = false;
    }
}
export class SIColorBlack extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Black, this.name = {
            key: 'strings:colonistCommon.playerColors.Black'
        }, this.price = 0, this.image = LobbyImage.StoreColorBlack, this.activeInStore = true;
    }
}
export class SIColorPurple extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Purple, this.name = {
            key: 'strings:colonistCommon.playerColors.Purple'
        }, this.price = 2500, this.image = LobbyImage.StoreColorPurple, this.activeInStore = true;
    }
}
export class SIColorMysticBlue extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.MysticBlue, this.name = {
            key: 'strings:colonistCommon.playerColors.MysticBlue'
        }, this.price = 5000, this.image = LobbyImage.StoreColorMysticBlue, this.activeInStore = true;
    }
}
export class SIColorWhite extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.White, this.name = {
            key: 'strings:colonistCommon.playerColors.White'
        }, this.price = 1000, this.image = LobbyImage.StoreColorWhite, this.activeInStore = true;
    }
}
export class SIColorPink extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Color, this.type = StorePlayerColor.Pink, this.name = {
            key: 'strings:colonistCommon.playerColors.Pink'
        }, this.price = 300000, this.imagePath = LobbyImage.StoreColorPink, this.activeInStore = false;
    }
}
